export default "__VITE_ASSET__C8d24m3I__"